import pzDialog from '@/components/pzDialog/index.js'
export default ({}, inject) => {
	inject('pzDialog', pzDialog)
}
